<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('label_set.update_title') }}</span>
            <span v-else>{{ $t('label_set.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary" />
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('name')">
          <label>{{ $t('label_set.name') }}</label>
          <b-form-input type="text" :placeholder="$t('label_set.name_placeholder')"
            :class="{ 'is-invalid': fErr('name') }" v-model="entity.name" />
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('data_type')">
          <label>{{ $t('label_set.data_type') }}</label>
          <b-form-select :placeholder="$t('label_set.placeholders.data_type')"
            :class="{ 'is-invalid': fErr('data_type') }" v-model="entity.data_type">
            <b-form-select-option v-for="type in types" :key="type" :value="type">
              {{ $t(`LabelSetType.${type}`, type) }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group :label="$t('label_set.sample_sets')">
          <treeselect :class="{ 'treeselect-error': fErr('sample_sets') }"
            :placeholder="$t('label_set.placeholders.sample_sets')" :multiple="true" :load-options="autocompleteSampleSet"
            :async="true" :defaultOptions="true" v-model="entity.sample_sets" />
          <span class="error-text">{{ fErr('sample_sets') }}</span>
        </b-form-group>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small />
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'LabelSets' }">
          <b-button type="reset" variant="info" class="ml-2">
            {{ $t('global.cancel') }}
          </b-button>
        </router-view>
      </div>
    </b-card>
    <!-- <LabelSetTags ref="tagList" v-if="isUpdateForm"/> -->
  </div>
</template>

<script>
import merge from 'lodash.merge';
import { mapState } from 'vuex';

// import LabelSetTags from '@/views/LabelSetTags/LabelSetTags';

import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Services from '@/services/index';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      errorMsg: this.errors,
      types: [],
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          name: '',
          data_type: '',
          sample_sets: [],
        };
      },
    },
  },
  components: {
    Treeselect,
    // LabelSetTags,
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
    ...mapState('Auth', ['activeProjectId']),
    projectId() { return this.project_id || this.activeProjectId; },
  },
  methods: {
    getForUpdate: Services.labelSets.editData,
    getForCreate: Services.labelSets.createData,
    pushUpdate: Services.labelSets.update,
    pushCreate: Services.labelSets.create,
    load() {
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? this.getForUpdate : this.getForCreate;
      action(this.projectId, this.$route.params.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.labelSet : { ...this.entity, ...data.data.labelSet };
        this.types = data.data.types;
        // this.$refs.tagList.getData();
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? this.pushUpdate : this.pushCreate;
      action(this.projectId, { ...this.entity, project_id: this.projectId }).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        if (!this.isUpdateForm) {
          // After successful create
          // if (this.$can('edit', 'label_sets')) {
          this.$router.push({ name: 'LabelSetUpdate', params: { id: data.data.id } });
          // } else { // do not redirect if cannot edit
          //   this.entity = this.$options.props.value.default();
          //   this.load();
          // }
        }
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },

    autocompleteSampleSet({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        Services.sampleSets.list(this.projectId, { notpaginate: 1, search: searchQuery }).then(({ data }) => {
          const options = data.data.map((i) => ({
            id: i.id,
            label: `${i.id} ${i.name}`,
          }));
          callback(null, options);
        });
      }
    },
  }
};
</script>
